










































import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { ExternalTemplateInformation, ExternalTemplatesInformation } from "../../../../domain/localhost/items";
import { DialogMixin } from "../../../system/mixins";
import { Dictionary } from "../../../../domain/system";

@Component({
  components: {
  },
})
export default class DynamicTemplateSelectDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      isTemplateMismatch: false,
      templatesInformation: null as ExternalTemplatesInformation,
      items: null as ExternalTemplateInformation[],
      selectedItem: null as ExternalTemplateInformation,
      result: null as string,
    };
  }
  isTemplateMismatch: boolean;
  templatesInformation: ExternalTemplatesInformation;
  items: ExternalTemplateInformation[];
  selectedItem: ExternalTemplateInformation;
  result: string;

  async show(codes: string[]): Promise<string> {
    if (!codes || codes.length === 0) { throw new Error("codes is empty!!!"); }
    if (codes.length === 1) { return codes[0]; }

    return this.showModal(async () => {
      this.isTemplateMismatch = false;
      this.items = null;
      this.selectedItem = null;
      this.result = null;

      if (!!this.templatesInformation) {
        this.setTemplateItems(codes);
      } else {
        this.getTemplatesInformation()
        .then(info => {
          if (!info) {
            this.$error("エラー", "テンプレート一覧の取得に失敗しました。");
            this.isVisible = false;
            return;
          }
          this.templatesInformation = info;
          this.setTemplateItems(codes);
        })
        .catch(e => {
          this.$error("エラー", "テンプレート一覧の取得に失敗しました。", e);
          this.isVisible = false;
        });
      }
      await this.waitHidden(true);
      return this.result;
    });
  }

  private async getTemplatesInformation(): Promise<ExternalTemplatesInformation> {
    const param = new Dictionary<string, string>();
    param.set("action", "dynamicTemplateQuery");
    const service = DomainRegistry.localhost.getApplicationService();
    const info = await service.launchResponsively(null, param, null);
    if (info instanceof ExternalTemplatesInformation) {
      return info;
    }
    throw new Error("invalid instance");
  }

  private setTemplateItems(codes: string[]): void {
    // ダイアログを開きなおしたときに前回選択したハイライトが中途半端に残るのでcloneで対策している
    this.items = this.templatesInformation.templates
      .filter(i => codes.indexOf(i.code) >= 0)
      .map(i => Object.freeze(i.clone()));
    if (this.items.length !== codes.length) {
      // フォーマットに指定されているテンプレートがローカルのフォルダに格納されていないとき
      this.isTemplateMismatch = true;
    }
  }

  selectAndClose(): void {
    if (!this.selectedItem) { return; }
    this.result = this.selectedItem.code;
    this.isVisible = false;
  }

  cancel(): void {
    this.result = null;
    this.isVisible = false;
  }

  handleSelectionChanged(row: ExternalTemplateInformation): void {
    this.selectedItem = row;
  }

  onRowDoubleClicked(): void {
    this.selectAndClose();
  }
}
